"use client"

import { create } from "zustand";

type Store = {
    states: Record<string, boolean>;
    toggleState: (value: string) => void
  }

export const useTrigger = create<Store>((set) => ({
    states: {
        isOpenMenu: false,
        isOpenCart: false,
        isOpenAdmin: false,
        isOpenSearch: false,
        isOpenFilter: false,
        isAlertModal: false
    },
    toggleState: (key) =>
        set((state) => ({
            states: { ...state.states, [key]: !state.states[key] },
        })),
}));

// "use client"

// import { useCallback, useState } from "react";

// type State = {
//     isOpenMenu: boolean;
//     isOpenCart: boolean;
//     isOpenAdmin: boolean;
//     isOpenSearch: boolean;
//     isOpenFilter: boolean;
//     isAlertModal: boolean;
// };

// export const useTrigger = () => {
//     const [states, setStates] = useState<State>({
//         isOpenMenu: false,
//         isOpenCart: false,
//         isOpenAdmin: false,
//         isOpenSearch: false,
//         isOpenFilter: false,
//         isAlertModal: true,
//     });

//     const toggleState = useCallback((key: keyof State) => {
//         console.info(key)
//         setStates((prevStates) => ({
//             ...prevStates,
//             [key]: !prevStates[key],
//         }));
//     }, []);

//     console.info(states)

//     return { states, toggleState }
// }
